import { AnimatedImageSection } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/__utils__/BottomSignUpBannerStyles";
import {
  BannerImageDimensions,
  IBannerImage,
  useGetBottomSignUpBannerImages,
} from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/__utils__/useGetBottomSignUpBannerProducts";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";
import styled, { css } from "styled-components";

export const BottomSignUpBannerImages: React.FC = () => {
  const { isMobile, isTablet, isDesktop } = useViewport();
  const rotatingBannerImages = useGetBottomSignUpBannerImages();

  const getImageDimensions = (dimensions: {
    [viewport: string]: BannerImageDimensions;
  }) => {
    if (isMobile) {
      return dimensions.mobile;
    } else if (isTablet) {
      return dimensions.tablet;
    } else if (isDesktop) {
      return dimensions.desktop;
    } else {
      return dimensions.xlarge;
    }
  };

  return (
    <ImagesWrapper>
      {rotatingBannerImages.map((imageData, index) => (
        <AnimatedImageSection key={imageData.keyword} $index={index}>
          {imageData.images.map((image: IBannerImage, imageIndex: number) => {
            const imageDimensions = getImageDimensions(image.dimensions);
            return (
              <StyledImage
                key={image.src}
                src={image.src}
                style={{
                  height: imageDimensions?.height,
                }}
                height={imageDimensions?.height}
                $top={imageDimensions?.top}
                $right={imageDimensions?.right}
                $bottom={imageDimensions?.bottom}
                $left={imageDimensions?.left}
                loading="lazy"
                alt=""
                $index={imageIndex}
              />
            );
          })}
        </AnimatedImageSection>
      ))}
    </ImagesWrapper>
  );
};

const ImagesWrapper = styled.div`
  position: relative;
  overflow: hidden;

  ${responsiveMediaQueries.mobile} {
    width: 264px;
    padding: 0 ${getSpacing("7x")};
    height: 400px;
  }
  ${responsiveMediaQueries.tabletAndAbove} {
    width: 100%;
    height: 440px;
  }
  ${responsiveMediaQueries.desktop} {
    height: 566px;
  }
  ${responsiveMediaQueries.xLargeAndAbove} {
    height: 631px;
  }
`;

const StyledImage = styled.img<{
  $top?: string;
  $right?: string;
  $bottom?: string;
  $left?: string;
  $index?: number;
}>`
  position: absolute;

  ${(props) => css`
    top: ${props?.$top};
    right: ${props?.$right};
    bottom: ${props?.$bottom};
    left: ${props?.$left};
  `}
  ${responsiveMediaQueries.mobile} {
    display: ${(props) =>
      props.$index === 0 || props.$index === 1 ? "none" : "block"};
  }
`;
